import axios from 'axios'
import moment from 'moment'
import qs from 'qs'
import { getUserTimezone, prepareReportsFiltersAsParams } from '../../../utils'

export async function getFileForExport(params) {
    const dateNow = moment(new Date()).format('DD.MM.YYYY')
    const timeNow = moment(new Date()).format('HH:mm')
    const timezone = getUserTimezone()
    params = { ...params, dateNow, timeNow, timezone }
    const preparedParams = prepareReportsFiltersAsParams(params)
    const response = await axios
        .get(`${process.env.API_URL}/reports/export`, {
            responseType: 'blob',
            params: preparedParams,
            paramsSerializer: params => {
                return qs.stringify(params)
            }
        })
        .catch(err => {
            console.error(err)
            return null
        })
    return response?.data
}

export async function replaceReportType(
    reportId,
    commentText,
    images,
    newType
) {
    const formData = new FormData()

    images?.forEach(image => {
        formData.append(`images`, image)
    })

    formData.append('comment_text', commentText)
    formData.append('new_type', newType)

    const response = await axios.patch(
        `${process.env.API_URL}/reports/${reportId}/replace-type`,
        formData,
        {
            headers: { 'Content-Type': 'multipart/form-data' }
        }
    )

    return response.data
}
